import {type FC, useMemo} from 'react';

import {i18n} from '@yourcoach/i18n';

import type {ChannelVariant} from '../../types';
import type {Props} from './types';

import * as S from './styles';

export const ChannelsListTabs: FC<Props> = ({
  onTabChange,
  selectedTab,
  tabs = ['course', 'dm'],
}) => {
  const allTabs: {key: ChannelVariant; title: string}[] = useMemo(
    () => [
      {key: 'course', title: i18n.t('shared:programs')},
      {key: 'course_individual', title: i18n.t('shared:active')},
      {
        key: 'course_individual_archived',
        title: i18n.t('shared:archived'),
      },
      {key: 'dm', title: i18n.t('shared:direct_messages')},
    ],
    [],
  );

  const tabsToRender = useMemo(
    () => tabs.map(tab => allTabs.find(({key}) => key === tab)).filter(Boolean),
    [allTabs, tabs],
  );

  const onTabClick = (key: ChannelVariant) => {
    onTabChange(key);
  };

  if (tabsToRender.length <= 1) {
    return null;
  }

  return (
    <S.Container>
      {tabsToRender.map(({key, title}) => (
        <S.Tab
          isSelected={key === selectedTab}
          key={key}
          onClick={() => onTabClick(key)}
        >
          <S.TabTitle isSelected={key === selectedTab}>{title}</S.TabTitle>
        </S.Tab>
      ))}
    </S.Container>
  );
};
